<script lang="ts" setup>
import { ElNotification } from "element-plus";
import { FormSizeType } from "~/types/element-ui/FormSizeType";
import { FormRuleType } from "~/types/element-ui/FormRuleType";
import { useDialogStore } from "~/projects/cc/stores/dialogStore";

const props = defineProps({
  phone: {
    type: String,
    default: "",
  },
});

const visible = ref(true);
const size: FormSizeType = "small";
const dialogStore = useDialogStore();

const handleAddContactFun = (done: () => void) => {
  dialogStore.setAddCustomerDialogVisibility(false);
  console.log(dialogStore.showAddCustomer);
};
</script>

<template>
  <!--Add Info-->
  <div class="sm:call">
    <client-only>
      <el-dialog
        v-model="dialogStore.showAddCustomer"
        :before-close="handleAddContactFun"
        :close-on-click-modal="false"
        :lock-scroll="false"
        :modal="false"
        draggable
        width="35%"
        class="centerModal"
      >
        <template #header="{ titleId }">
          <div class="my-header flex items-center gap-2">
            <h4 :id="titleId" class="text-md text-white">
              {{ dialogStore.currentCustomer.first_name ? "Edit " : "Create " }}
              Customer
            </h4>
            <Svgs class="text-white w-5 mb-1" name="pen" />
          </div>
        </template>

        <div class="p-2">
          <CustomersEditForm
            v-if="dialogStore.currentCustomer.first_name"
            :show-edit-modal-header="false"
            @close="dialogStore.setAddCustomerDialogVisibility(false)"
          ></CustomersEditForm>
          <CustomersCreateForm
            v-else
            :show-edit-modal-header="false"
            :phone="dialogStore.ongoingCallNumber"
            @close="dialogStore.setAddCustomerDialogVisibility(false)"
          />
        </div>
      </el-dialog>
    </client-only>
  </div>
</template>

<style scoped></style>
